import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FormNewCandidato from "./formNewCandidatoNp";

const NewCandidatoFormModal = ({ toggle, isOpen, derivacionId, notaDePedidoId, handleCreateCandidato }) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: " #f8f8f8" }}>
          Nuevo candidato
        </ModalHeader>
        <ModalBody style={{ background: " #f8f8f8" }}>
          <FormNewCandidato toggle={toggle} notaDePedidoId={notaDePedidoId} handleCreateCandidato={handleCreateCandidato} derivacionId={derivacionId} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default NewCandidatoFormModal;
